import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { AppText, styled, Box, TabbedContentContainer, TabsHeader, Header, Row, } from '@streem/ui-react';
import { useObservable } from '../../../hooks/rxjs';
import { useRoomSession } from '../../../context/room_session';
import { InCallStreemshots } from './in_call_streemshots';
import { InCallBookmarks } from './in_call_bookmarks';
import { LegacyInCallNotes } from './legacy_in_call_notes';
import { LegacyInCallCustomerDetails } from './legacy_in_call_customer_details';
import { useBookmarkToSelect } from '../../../hooks/use_bookmark_to_select';
import { useMediaBreakpoint } from '../../../hooks/use_media_breakpoint';
import { NetworkQuality } from './network_quality/network_quality';
import { useCompanySettings } from '../../../context/company_settings';
import { ShareLinkButton } from '../video_frame/share_link/share_link_button';
import { useCompanyInfo } from '../../../context/company_info';
import { InCallCallDetails } from './call_details/in_call_call_details';
import { BrandLogo } from '../../brand_logo';
export var DetailsTabs;
(function (DetailsTabs) {
    DetailsTabs[DetailsTabs["Notes"] = 0] = "Notes";
    DetailsTabs[DetailsTabs["Streemshots"] = 1] = "Streemshots";
    DetailsTabs[DetailsTabs["Bookmarks"] = 2] = "Bookmarks";
    DetailsTabs[DetailsTabs["Measurements"] = 3] = "Measurements";
    DetailsTabs[DetailsTabs["Details"] = 4] = "Details";
})(DetailsTabs || (DetailsTabs = {}));
export const InCallDetailsContentTray = ({ isTrayOpen, }) => {
    const [activeTab, setActiveTab] = useState(DetailsTabs.Notes);
    const roomSession = useRoomSession();
    const companySettings = useCompanySettings();
    const { isSmallScreen } = useMediaBreakpoint();
    const [bookmarkToSelect] = useBookmarkToSelect();
    const [remoteUser] = useObservable(roomSession.user.remoteUser);
    const [room] = useObservable(roomSession?.room.room);
    const companyInfo = useCompanyInfo();
    const brandSettings = roomSession.callSettings.brandSettings;
    useEffect(() => {
        if (bookmarkToSelect) {
            setActiveTab(DetailsTabs.Bookmarks);
        }
    }, [bookmarkToSelect]);
    const tabs = [
        {
            key: DetailsTabs.Notes,
            title: 'Notes',
            content: _jsx(LegacyInCallNotes, {}, "in-call-notes"),
        },
    ];
    if (roomSession.callSettings.showReservationCallDetailYn && room?.callDetail) {
        tabs.push({
            key: DetailsTabs.Details,
            title: 'Details',
            content: (_jsx(InCallCallDetails, { room: room, isTrayOpen: isTrayOpen }, "in-call-call-detail")),
        });
    }
    else if (room?.details?.length) {
        tabs.push({
            key: DetailsTabs.Details,
            title: 'Details',
            content: _jsx(LegacyInCallCustomerDetails, {}, "in-call-customer-details"),
        });
    }
    tabs.push({
        key: DetailsTabs.Streemshots,
        title: 'Streemshots',
        content: _jsx(InCallStreemshots, {}, "in-call-streemshots"),
    });
    tabs.push({
        key: DetailsTabs.Bookmarks,
        title: 'Bookmarks',
        content: _jsx(InCallBookmarks, {}, "in-call-bookmarks"),
    });
    return (_jsxs(InCallDetailsContentContainer, { children: [_jsxs(HeaderWrapper, { children: [roomSession.callSettings.showReservationCallDetailYn && brandSettings && (_jsx(BrandHeader, { "data-testid": "in-call-brand-header", brandLogoUrl: brandSettings.brandLogoUrl ?? null, brandName: brandSettings.brandName ?? (companyInfo?.companyName || 'Streem') })), _jsx(CustomerHeader, { customerName: remoteUser?.name, roomSessionSid: roomSession.roomId.toString(), companyName: companyInfo?.companyName, anonymousShareEnabled: !!companySettings?.anonymousShareEnabled }), _jsx(NetworkQuality, {}), _jsx(TabsHeader, { tabs: tabs, activeTab: activeTab, setActiveTab: setActiveTab, isSmallScreen: isSmallScreen, dataTestId: "in-call-details-tabs-header" })] }), _jsx(TabbedContentContainer, { tabs: tabs, activeTabKey: activeTab, setActiveTabKey: setActiveTab, dataTestId: "in-call-details-tab-content" })] }));
};
const BrandHeader = ({ brandLogoUrl, brandName }) => {
    return (_jsxs(Row, { alignItems: "center", style: { marginBottom: '1rem' }, children: [brandLogoUrl && (_jsx(BrandLogo, { logoUrl: brandLogoUrl, "data-testid": "in-call-brand-logo" })), _jsx(Header, { size: "xxlarge", style: { padding: '0.1875rem 0' }, "data-testid": "in-call-brand-name", children: brandName })] }));
};
const CustomerHeader = ({ customerName = 'Customer', roomSessionSid, companyName, anonymousShareEnabled }) => {
    return (_jsxs(CustomerNameHeader, { "data-testid": "in-call-customer-name-header", "data-clarity-mask": "true", children: [_jsx(AppText, { headingFontFamily: true, as: "h4", size: "mediumLarge", style: { overflowWrap: 'anywhere' }, children: customerName }), _jsx(ShareLinkButton, { roomSid: roomSessionSid, companyName: companyName, anonymousShareEnabled: anonymousShareEnabled })] }));
};
const HeaderWrapper = styled(Box)(({ theme }) => ({
    position: 'sticky',
    top: '0',
    backgroundColor: theme.colors.white,
    width: '100%',
    zIndex: 1,
    paddingTop: '16px',
}));
const InCallDetailsContentContainer = styled(Box)(({ theme }) => ({
    padding: '0 24px',
    backgroundColor: theme.colors.white,
}));
const CustomerNameHeader = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
});
//# sourceMappingURL=in_call_details_content_tray.js.map